module.exports = __webpack_public_path__ + "static/img/psalm.1dfb755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/psalm.jpg
// module id = 2P66
// module chunks = 35